// Single source of truth for the app's brand. Change here to rebrand the whole UI.
export const BRAND = {
  name: "HITMAN",
  short: "HITMAN",
  sub: "",
  logoUrl: "/assets/logo.png",
};
